import { Component, OnInit, Input, inject, DestroyRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { translate } from '@jsverse/transloco';
import { Constants } from 'src/app/models/constants';
import { FormUtilService } from 'src/app/services/util/form-util.service';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
// import { MgmtConfigurationService } from 'src/app/services/api/mgmt-configuration.service';
import { SolutionVersionsService } from 'src/app/services/util/solution-versions.service';
import { SolutionsService } from 'src/app/services/api/solutions.service';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { ExternalPackageDetailsComponent } from '../../external-package/external-package-details/external-package-details.component';
import { ActivatedRoute, Router } from '@angular/router';
import { BreadcrumbItem } from 'src/app/models/breadcrumb/breadcrumb-item';
import { RouterSegments } from 'src/app/models/router-segments';
import { BlueprintsService } from 'src/app/services/api/blueprints.service';
import { InstancesService } from 'src/app/services/api/instances.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ComponentDependencyComponent } from '../component-dependency/component-dependency.component';
import { PackageUpdatePopupComponent } from '../package-update-popup/package-update-popup.component';
import { GenericErrorComponent } from 'src/app/components/generic-error/generic-error.component';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import { PathToLiveEnvironment } from 'src/app/models/blueprints/path-to-live-environment';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';
import { forkJoin, map, Observable } from 'rxjs';
import { ActivityService } from 'src/app/services/api/activity.service';
@Component({
    selector: 'app-component-update',
    templateUrl: './component-update.component.html',
    styleUrls: ['./component-update.component.scss'],
    standalone: false
})
export class ComponentUpdateComponent   implements OnInit {
  @Input() data;
  private destroyRef = inject(DestroyRef);

  Constants = Constants;
  title: string;
  updateBuildForm: FormGroup;
  textbutton: string;
  index: any;
  versionData = [];
  dataselectedVersionId: any;
  dataselectedVersion: any;
  version: any;
  externalSelected: any;
  addExternalOption = false;
  tenantId: any;
  dropdownLoader: boolean;
  solutionVersionData: any;
  breadcrumbItems: BreadcrumbItem[] = [];
  blueprintId: any;
  instanceId: any;
  instanceData: any;
  blueprintData: any;
  solutionId: any;
  instanceVersion: any;
  components: any;
  componentsArray: string[];
  selectedComponentsArray = [];
  datazoneColumns: string[] = ['name', 'value', 'dependents', 'addDependents', 'delete'];
  selectedComponent: string;
  componentValue: string;
  versionValue: string;
  solutionVersionIdData: any;
  solutionVersionId: any;
  dependentsAvailable = true;
  missingDependency = [];
  summaryPage: boolean;
  versionSelected: any;
  customPackage: any;
  enableContinue: boolean;
  initialAdd: boolean = true;
  showDropdown = true;
  componentEnable: boolean;
  addEnable: boolean;
  tableRender: boolean;
  failedClicked: boolean;
  tableLoader: boolean;
  instanceSolutionVersionId: string;
  searchValue: any;
  filteredVersions: any;
  versionsList = [];
  selectedVersion: any;
  preprodData :any;
  readonly WARNING_STATUS =[DeployStatus.FAILED, DeployStatus.CONFIGURATION_FAILED, DeployStatus.TEST_FAILED];

  constructor(private authService: AuthService, private router: Router, private instancesService: InstancesService, private blueprintsService: BlueprintsService, private formBuilder: FormBuilder, public sidenavService: SidenavService,
     // private configurationService: MgmtConfigurationService,
     public dialog: MatDialog, private solutionsService: SolutionsService, private toastrService: CustomToastrService,
     public solutionVersionsService: SolutionVersionsService, public route: ActivatedRoute, private activityService: ActivityService) {
      
     }

    ngOnInit(): void {
      this.dropdownLoader = false;
      this.tenantId = this.route.snapshot.params.id;
      this.solutionId = this.route.snapshot.params.solutionId;
      this.blueprintId = this.route.snapshot.params.blueprintId;
      this.instanceId = this.route.snapshot.params.instanceId;
      this.preprodData = JSON.parse(localStorage.getItem("preprodData"));
        this.instancesService.getInstanceById(this.instanceId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(instance => {
        this.data = instance;
        this.instanceSolutionVersionId = instance?.solutionVersionId;
        if(this.WARNING_STATUS.includes(instance.status)){
          forkJoin({showWarning: this.getInstaceActivity(instance.id)}).subscribe(({ showWarning }) => {
            this.data.showWarningPopup = showWarning;
          });
        }
        this.solutionsService.getSolutionVersions(this.solutionId).pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
          if (data) {
            this.solutionVersionIdData = data;
              data.forEach(element => {
                this.versionData.push(element);
                if(this.data.solutionVersionId === element.id) {
                  this.instanceVersion = element;
                }
              });
              if (this.instanceVersion) {
                let versions = [];
                this.versionData?.forEach(item => {
                  if (item?.version.localeCompare(this.instanceVersion.version) === 1) {
                    if (this.data.targetEnvironment === PathToLiveEnvironment.LIVE && this.preprodData?.version ===  item.version) {
                      versions = [...versions, item];
                    }
                    if (this.data.targetEnvironment !== PathToLiveEnvironment.LIVE) {
                      versions = [...versions, item];
                    }
                  }
                })
                this.versionData = versions;
                this.versionGroup(versions);
              }
              // this.versionData.sort((a, b) => {
              //   return b.version.localeCompare(a.version);
              // });
              this.versionData = this.versionData.map(item => item?.version);
            this.dropdownLoader = true;
          }
        if(this.versionData.length === 0) {
          const noRelease = 'Release not Available';
          this.versionData.push(noRelease);
        }
      },
      (error) => {
        setTimeout(() => {
		  const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
        this.blueprintsService.getBlueprint(this.blueprintId).pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(task => {
          this.blueprintData = task;
          this.breadcrumbItems.push(
          {label: translate('TENANT_CONTINUOUS_UPDATE.CONTINUOUS_UPDATE'), url: [RouterSegments.TENANT, this.tenantId, RouterSegments.CONTINUOUS_UPDATE]},
          {label: task.name},
          {label: this.data.name}
        )
      });
    });
      
      
  }

  createForm(): void {
    const formConfig: any = {
      buildVersion: [undefined, [Validators.required]],
      searchValue: ['']
    };
    this.updateBuildForm = this.formBuilder.group(formConfig);
    // if (this.data?.configurationId) {
    //   this.configurationService.getConfigurationsMgmtById(this.data?.configurationId)
    //   .pipe(takeUntilDestroyed(this.destroyRef))
    //   .subscribe(version => {
    //     this.version = version;
    //   });
    // }
  }

  searchChanged(value): void {
    this.versionData = this.versionsList;
  }

  resetFilter(): void {
    this.searchValue = undefined;
    this.versionData = this.versionsList;
  }

  getSelectedVersion(data): void {
    this.versionSelected = data;
    if(this.versionData.length === 1 && data === 'Release not Available') {
      this.componentEnable = false;
    } else {
    this.componentEnable = true;
    }
    this.solutionVersionId = this.solutionVersionIdData.find(item => item.version === data)?.id;
    this.componentData(this.solutionId, this.solutionVersionId);
    if(this.instanceVersion?.releaseVersion?.split('.',1).toString() === data.split('.',1).toString())  {
      this.addExternalOption = true;
    }
  }

  versionGroup(versions) {
    let group = [];
    this.versionsList = versions;
    this.versionsList.forEach(item => {
      group.push(item?.version?.split('.')[0]);
    });
    group = [...new Set(group)];

    let makeGrouping = [];
    group.forEach(groupItem => {
      const versions = this.versionsList.filter(item => item?.version?.split('.')[0] === groupItem);
      const groupName = {version: groupItem, group: true};
      versions.push(groupName);      
      makeGrouping.push(versions);
    });

    const combineData = makeGrouping.flat();
    const finalData = combineData.sort((a, b) => { 
      if (a.version < b.version) return -1;
      if (a.version > b.version) return 1;
    })

    this.versionsList = finalData;
    this.versionData = finalData;
  }

  componentData(solutionId, solutionVersionId): void {
  this.solutionsService.getSolutionVersionManifestById(solutionId, solutionVersionId)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe((component: any) => {
           if (component) {
            this.components = component;
            const mapped = Object.keys(this.components.components).map(key => ({name: key, version: this.components.components[key]}));
            const data: any = mapped.filter(item => item.version === this.versionSelected);
            this.componentsArray =  data.map(item => item.name);
          /* this will be used once the engine fixed for that status issue with component updates.*/
          //   if(this.data?.components) {
          //     const instanceMapped: any = Object.keys(this.data?.components).map(key => ({name: key, version: this.data?.components[key]}));
          //     let finalArray = [];
          //     data.forEach(item => {
          //       if (instanceMapped?.find(component => item.name === component.name && (item.version.localeCompare(component.version)) === 1)) {
          //         finalArray = [...finalArray, item];
          //       } else if (!instanceMapped?.find(component => item.name === component.name)) {
          //         finalArray = [...finalArray, item];
          //       }
          //     })
          //   this.componentsArray = finalArray.map(item => item.name);
          //  } else {
          //   this.componentsArray =  data.map(item => item.name);
          //  }
           }
          });
        }

  goToTenant(): void {
    this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT, this.tenantId, RouterSegments.CONTINUOUS_UPDATE, RouterSegments.BLUEPRINTS, this.blueprintId]);
  }

  submit(): void {
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('INSTANCE_DETAILS.UPDATE_BUILD.TITLE'),
        message: translate('INSTANCE_DETAILS.UPDATE_BUILD.MESSAGE') + this.versionSelected,
        confirmButtonText: translate('BUTTONS.CONFIRM')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {
          if(this.externalSelected) {
            this.customPackage = this.data.packageReferenceId;
          } else {
            this.customPackage = undefined;
          }
          let componentObj: any = {}
          this.selectedComponentsArray.forEach(item => {
            componentObj[item.name] = this.components.components[item.name];
            componentObj = componentObj;
          })
          

          const versionForm = {
            id: this.data.id,
            targetSolutionVersionId: this.instanceSolutionVersionId,
            packageReferenceId: this.customPackage,
            components: componentObj
          };
          this.instancesService.putBuildVersion(versionForm)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(reposnse => {
            this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT, this.tenantId, RouterSegments.CONTINUOUS_UPDATE, this.solutionId, this.blueprintId, RouterSegments.INSTANCE]);
            setTimeout(() => {
              const title = translate('ADD_VERSION.BUILD_VERSION');
              const message = translate('INSTANCE_DETAILS.UPDATE_BUILD.MESSAGE_SUCCESS');
              this.toastrService.successMessage(message, title);
            }, 500);
          },
          (error) => {
          const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
              this.dialog.open(ErrorDialogComponent, {
                    minHeight: '342px',
                    width: '630px',
                    panelClass: 'flex-dialog',
                    data: {
                      title: translate('ERROR_DIALOG.UPDATE_BUILD_FAILED'),
                      description: errorMessage
                    }
              });
          });
        }
        });
  }

  onOptionsSearched(data): void {
    this.versionData = this.versionsList.filter(item => item?.version.includes(data));
  }

  customPackageView(): void {
      if (this.data.packageReferenceId) {
        this.dialog.open(ExternalPackageDetailsComponent, {
          height: '85vh',
          width: '50vw',
          panelClass: 'custom-pack-dialog',
          data: this.data
        })
        .afterClosed()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(result => {
          if (result) {
          }
        });
      }
    }

  onComponentSelected(data): void {
    this.selectedComponent = data;
    if(this.selectedComponent) {
      if(this.enableContinue === undefined || this.enableContinue || this.selectedComponentsArray.length === 0 ) {
      this.addEnable = true;
      }
    } else {
      this.addEnable = false;
    }
    this.componentValue = data;
  }

  add(): void {
    this.addEnable = false;
    this.tableLoader = true;
    this.enableContinue = false;
    const componentObj: any = {}
    componentObj[this.selectedComponent] = this.components.components[this.selectedComponent];

    const data = {
      id: this.instanceId,
      targetSolutionVersionId : this.instanceSolutionVersionId,
      components: componentObj
    }
    this.instancesService.putUpdateVerification(data).pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((dependents: any) => {
    if(dependents?.verification === 'success') {
    this.tableLoader = false;
    this.showDropdown = false;
    this.componentsArray = this.componentsArray.filter(item => item !== this.selectedComponent);
    setTimeout(() => {
      this.showDropdown = true;
    }, 10);
      const obj: any = {
        name: this.selectedComponent,
        value: this.components.components[this.selectedComponent],
        dependentsAvailable: false
      }
      this.selectedComponentsArray = [...this.selectedComponentsArray, obj];
      this.tableRender = true;
      this.addEnable = false;
      this.enableContinue = this.selectedComponentsArray.some(item => item.dependentsAvailable === true) ? false : true;
    } else if(dependents?.verification === 'failed' && dependents?.components[0]?.missingDependency) {
        this.tableLoader = false;
      this.missingDependency = dependents?.components[0]?.missingDependency;
          this.showDropdown = false;
          this.componentsArray = this.componentsArray.filter(item => item !== this.selectedComponent);
          setTimeout(() => {
            this.showDropdown = true;
          }, 10);
          const obj: any = {
            name: this.selectedComponent,
            value: this.components.components[this.selectedComponent],
            missingDependency: this.missingDependency,
            dependentsAvailable: true
          }
          this.selectedComponentsArray = [...this.selectedComponentsArray, obj];
          this.tableRender = true;
          this.addEnable = this.selectedComponentsArray.some(item => item.dependentsAvailable === true) ? false : true;
          this.enableContinue = this.selectedComponentsArray.some(item => item.dependentsAvailable === true) ? false : true;
        }
      }, error => {
          this.tableLoader = false;
          this.showDropdown = false;
          this.componentsArray = this.componentsArray.filter(item => item !== this.selectedComponent);
            setTimeout(() => {
            this.showDropdown = true;
          }, 10);
          const obj: any = {
            name: this.selectedComponent,
            value: this.components.components[this.selectedComponent],
            dependentsAvailable: false,
            dependencyVerification: true
          }
          this.selectedComponentsArray = [...this.selectedComponentsArray, obj];
          this.tableRender = true;
          this.addEnable = false;
          this.enableContinue = false;
          const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
          this.dialog.open(ErrorDialogComponent, {
            minHeight: '342px',
            width: '566px',
            panelClass: 'flex-dialog',
            data: {
              title:  translate('NOTIFICATIONS.COMPONENT_UPDATE_FAILED'),
              description: errorMessage,
            }
          });
        });
      }

  failed(): void{
    this.failedClicked = true;
    const componentObj: any = {}
    componentObj[this.selectedComponent] = this.components.components[this.selectedComponent];

    const data = {
      id: this.instanceId,
      targetSolutionVersionId : this.instanceSolutionVersionId,
      components: componentObj
    }
    this.instancesService.putUpdateVerification(data).pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((dependents: any) => {}, error => {
      this.failedClicked = false;
      const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
      this.dialog.open(ErrorDialogComponent, {
        minHeight: '342px',
        width: '566px',
        panelClass: 'flex-dialog',
        data: {
          title:  translate('NOTIFICATIONS.COMPONENT_UPDATE_FAILED'),
          description: errorMessage,
        }
      });
    })
  }

  dependentAddition(): void {
    const data = {
      missingDependency: this.missingDependency
    };
    this.sidenavService.openInRightSidenav(ComponentDependencyComponent, data);
  }

  addDependent(): void {
    let data;
    this.showDropdown = false;
    this.missingDependency.forEach(item => {
      this.componentsArray = this.componentsArray.filter(element => element !== item);
      data = {
        name: item,
        value: this.components.components[item],
        dependent: true
      }
      this.selectedComponentsArray = [...this.selectedComponentsArray, data];
    })
    setTimeout(() => {
      this.showDropdown = true;
    }, 10);
    this.selectedComponentsArray.find(item => item.name === this.selectedComponent).dependentsAvailable = false;
    this.enableContinue = this.selectedComponentsArray.some(item => item.dependentsAvailable === true) ? false : true;
  }

  clickContinue(): void {
    if(this.summaryPage) {
      // displaying warning popup for failed environment.Upon user confirmation, proceed with submission.
      if (this.data.showWarningPopup) {
        this.dialog.open(ConfirmationDialogComponent, {
          panelClass: 'default-dialog-wrapper',
          width: '650px',
          autoFocus: false,
          data: {
            title: translate('INSTANCE_DETAILS.UPDATE_BUILD.WARNING_TITLE', {
              action: translate('INSTANCE_DETAILS.COMPONENT_UPDATE')}),
            message: translate('INSTANCE_DETAILS.UPDATE_BUILD.WARNING_NOTE', {
              action: translate('INSTANCE_DETAILS.COMPONENT_UPDATE'),
            }),
            confirmButtonText: translate('INSTANCE_DETAILS.UPDATE_BUILD.PROCEED'),
            warning: true
          },
        })
        .afterClosed()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((confirm) => {
          if (confirm) {
            this.submit();
          }
        });
      } else {
        this.submit();
      }
    } else {
      this.summaryPage = true;
    }
  }

  delete(element): void {
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
          width: '566px',
          autoFocus: false,
          data: {
            title: translate('INSTANCE_DETAILS.COMPONENTS_UPDATE_TITLE'),
            message: translate('INSTANCE_DETAILS.COMPONENTS_UPDATE_MESSAGE'),
            confirmButtonText: translate('BUTTONS.DELETE')
          }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
      if (confirm) {
      if(element?.missingDependency?.length > 0) {
        element.missingDependency.forEach(dependentItem => {
          const selectedComp = this.selectedComponentsArray.map(item => item.name);
          const dependentIndex = selectedComp?.indexOf(dependentItem);
          this.selectedComponentsArray.splice(dependentIndex, 1);
          this.componentsArray.push(dependentItem);
        })
      }
      this.addEnable = false;
        const selectedComp = this.selectedComponentsArray.map(item => item.name);
        const index = selectedComp?.indexOf(element.name);
        this.selectedComponentsArray.splice(index, 1);
        if(this.selectedComponentsArray.length === 0) {
          this.enableContinue = false;
        }
        this.showDropdown = false;
        this.componentsArray.push(element.name);
        this.tableRender = false;
        setTimeout(() => {
          this.tableRender = true;
          }, 10);
        setTimeout(() => {
        this.showDropdown = true;
        }, 10);
      }
    })
  }

  selectExternalTypes(): void {
    if(this.externalSelected) {
      this.externalSelected = false;
    } else {
      this.externalSelected = true;
    }
  }
/**
 * 
 * @param instanceId 
 * @returns true if the instance has a latest failed config activity.
 */
getInstaceActivity(instanceId): Observable<boolean> {
  return this.activityService.getInstanceActivityLogs(instanceId).pipe(takeUntilDestroyed(this.destroyRef),
    map(data => {
      if (!data?.length) {
        return false;
      }
      const latestAction = data.filter(log => log?.status === 'failed' && log?.action === 'config').sort((a, b) =>
        new Date(b?.startTime).getTime() -new Date(a?.startTime).getTime())[0];
      return !!latestAction;
    })
  );
}

}

